import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutionimpact() {
  return (
    <section className="solution_impact p-100 bg_blue">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto resp_order text-center"
          >
            <div className="solution_impact">
              <StaticImage
                src="../../../images/case-studies/impact/solution.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={784}
                height={652}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>The Solution</h2>
            <p>
              By bridging the communication gap between the internal staff of an
              educational institute with a web app, Tekrevol was able to
              determine the students with a low level of emotional intelligence.
            </p>
            <p>
              We leverage emerging and conventional technologies to create an
              interactive interface that allows students to input their data,
              feelings, and other critical information.
            </p>
            <p>
              After collecting the information, the web app was programmed to
              analyze it to give a percentage of E.Q in the students. The web
              app also allowed the internal staff of an organization to monitor
              the mood of their students, which also resulted in several
              findings in the long run.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutionimpact;
